import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { url } from "../base/Variables";
import { LazyAxios, getToken, handleRequest, catchError } from "../base/index";

const baseUrl = `${url}/api/v1/user/address`

const initialState = {
    address_loading: false,
    address_error: null,
    address_error_type: null,
    address_success: null,
    all_address: null,
}

const getAllAddress = createAsyncThunk('getAllAddress', async (_, { rejectWithValue }) => {
    try {
        const token = getToken()
        const axios = await LazyAxios()
        const request = await axios.get(`${baseUrl}/`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})

// const getAddress()

const addressSlice = createSlice({
    name: 'addressSlice',
    initialState: initialState,
    reducers: {
        // set address slice to default
        addressSliceDefault(state, action) {
            state.address_loading = false
            state.address_error = null
            state.address_error_type = null
            state.address_success = null
            state.all_address = null
        },
        // add newly saved address
        addNewAddress(state, action) {
            state.all_address = state.all_address ? [...state.all_address, action.payload] : state.all_address
        },
        // update the saved address
        updateAddress(state, action) {
            state.all_address = state.all_address ? state.all_address.map((item) => {
                if (item.id === action.payload.id) {
                    return action.payload
                }
                else {
                    return item
                }
            }) : state.all_address
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllAddress.pending, (state) => {
                state.address_loading = true
                state.address_error = null
                state.address_error_type = null
                state.address_success = null
            })
            .addCase(getAllAddress.fulfilled, (state, action) => {
                state.address_loading = false
                state.all_address = action.payload.data
            })
            .addCase(getAllAddress.rejected, (state, action) => {
                state.address_loading = false
                state.address_error = action.payload.error_message
                state.address_error_type = action.payload.type
            })

    }
})

export default addressSlice
export { getAllAddress }
export const { addressSliceDefault, addNewAddress, updateAddress } = addressSlice.actions